// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dropdown-menu {\r\n    overflow: scroll;\r\n    max-height: 250px;\r\n    overflow-x: hidden;\n}\r\n/* ::-webkit-scrollbar{width:20px;} */\r\n\r\n", ""]);
// Exports
module.exports = exports;
